.sidebar {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  height: 100vh;
  height: 100dvh;
  position: sticky;
  top: 0;
  padding: var(--space-5) var(--space-3) var(--space-4);
  background: var(--bg-surface-sunken);
  border-right: 1px solid var(--border-subtle);
  overflow-y: auto;
}

.brand {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: 0 var(--space-2) var(--space-5);
}

.mark {
  object-fit: contain;
  width: 32px;
  height: 32px;
  filter: invert(1);
  flex-shrink: 0;
}

:global(:root[data-theme='light']) .mark {
  filter: none;
}

.wordmark {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
  min-width: 0;
}

.wordmarkTop {
  font-size: var(--text-md);
  font-weight: var(--weight-bold);
  letter-spacing: -0.02em;
}

.wordmarkBottom {
  font-size: var(--text-2xs);
  font-weight: var(--weight-semibold);
  letter-spacing: var(--tracking-wider);
  text-transform: uppercase;
  color: var(--text-tertiary);
}

.section {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: var(--space-4);
}

.sectionLabel {
  padding: 0 var(--space-3) var(--space-2);
  font-size: var(--text-2xs);
  font-weight: var(--weight-semibold);
  letter-spacing: var(--tracking-wider);
  text-transform: uppercase;
  color: var(--text-tertiary);
}

.item {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-md);
  color: var(--text-secondary);
  font-size: var(--text-base);
  font-weight: var(--weight-medium);
  transition:
    background var(--duration-fast) var(--ease-out),
    color var(--duration-fast) var(--ease-out);
}

.item:hover {
  background: var(--bg-hover);
  color: var(--text-primary);
  text-decoration: none;
}

.itemActive {
  background: var(--bg-selected);
  color: var(--text-primary);
}

.itemActive .itemIcon {
  color: var(--accent);
}

.itemIcon {
  flex-shrink: 0;
  color: var(--text-tertiary);
}

.itemLabel {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.soon {
  font-size: 9px;
  font-weight: var(--weight-semibold);
  letter-spacing: var(--tracking-wide);
  text-transform: uppercase;
  color: var(--text-tertiary);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-pill);
  padding: 1px 6px;
}

.footer {
  margin-top: auto;
  padding: var(--space-3) var(--space-3) 0;
  border-top: 1px solid var(--border-subtle);
  font-size: var(--text-2xs);
  color: var(--text-tertiary);
  line-height: var(--leading-relaxed);
}

.endpoint {
  font-family: var(--font-mono);
  overflow-wrap: anywhere;
}

/* ---- Drawer behaviour below the desktop breakpoint ---- */
@media (max-width: 1024px) {
  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    z-index: var(--z-sidebar);
    width: var(--sidebar-width);
    transform: translateX(-100%);
    transition: transform var(--duration-normal) var(--ease-out);
    box-shadow: var(--shadow-lg);
  }

  .open {
    transform: none;
  }
}
